import { createId } from '@paralleldrive/cuid2';
import { z } from 'zod';
import { LongGameError } from './error.js';
export const resourceIdTypes = {
    u: 'User',
    a: 'Account',
    f: 'Friendship',
    fi: 'FriendshipInvitation',
    cm: 'ChatMessage',
    gs: 'GameSession',
    gsi: 'GameSessionInvitation',
    gsl: 'GameSessionInvitationLink',
    t: 'Turn',
    vc: 'VerificationCode',
    no: 'Notification',
    ugp: 'UserGamePurchase',
    gp: 'GameProduct',
    gpi: 'GameProductItem',
};
export function id(prefix) {
    return `${prefix}-${createId()}`;
}
export function isPrefixedId(id, prefix) {
    return id.includes('-') && (!prefix || id.startsWith(prefix + '-'));
}
export function assertPrefixedId(id, prefix) {
    if (!isPrefixedId(id, prefix)) {
        throw new LongGameError(LongGameError.Code.BadRequest, `Invalid ${prefix ?? ''} id: ${id}`);
    }
}
export function idToType(id) {
    const prefix = id.split('-')[0];
    if (!resourceIdTypes[prefix]) {
        throw new LongGameError(LongGameError.Code.InternalServerError, `Invalid id: ${id}`);
    }
    return resourceIdTypes[prefix];
}
export function genericId() {
    return createId();
}
// Zod shapes for different ids
function createZodIdShape(prefix) {
    return z
        .custom((v) => isPrefixedId(v, prefix))
        .describe(`The ID of the ${resourceIdTypes[prefix]}. ${prefix}- prefixed IDs are used for ${resourceIdTypes[prefix]}.`);
}
export const idShapes = Object.entries(resourceIdTypes).reduce((acc, [prefix, name]) => {
    acc[name] = createZodIdShape(prefix);
    return acc;
}, {});
export function normalizeVersion(version) {
    let normalVersion = version.toString();
    if (!normalVersion.startsWith('v')) {
        normalVersion = `v${normalVersion}`;
    }
    if (normalVersion.includes('.')) {
        normalVersion = normalVersion.split('.')[0];
    }
    return normalVersion;
}
export function normalizeGameId(id, version, delimiter) {
    const normalVersion = normalizeVersion(version);
    return `${id.replace(/-/g, delimiter)}${delimiter}${normalVersion}`;
}
export function idToFederationId(id, version) {
    return normalizeGameId(id, version, '_');
}
//# sourceMappingURL=ids.js.map